import clsx from 'clsx';

export type ImageAndTextProps = {
  className?: string;
  image?: React.ReactNode;
  imagePosition?: 'before' | 'after';
  title?: string;
  body?: string | React.ReactNode;
};

export const ImageAndText = ({
  className = '',
  image,
  imagePosition = 'before',
  title = '',
  body,
}: ImageAndTextProps) => {
  const block = (
    <article
      className={clsx('sm:flex', 'relative', 'w-full', className, {
        'sm:flex-row-reverse': imagePosition === 'after',
      })}
    >
      <div className={clsx('sm:w-2/5')}>
        <figure
          className={clsx(
            'w-full',
            'object-cover-child-img',
            'relative',
            'aspect-square'
          )}
        >
          {typeof image === 'string' ? (
            <img src={image} alt="Preview image" className="h-full w-full" />
          ) : (
            image
          )}
        </figure>
      </div>

      <div
        className={clsx(
          'p-4',
          'sm:w-3/5',
          'sm:px-20',
          'flex',
          'flex-col',
          'justify-center'
        )}
      >
        <div>
          <header>
            {title && (
              <h3 className="hd-lg sm:hd-xl md:hd-xl mb-3 break-words">
                {title}
              </h3>
            )}
          </header>
          {body && <div className="body-base md:body-md space-y-4">{body}</div>}
        </div>
      </div>
    </article>
  );

  return block;
};

export default ImageAndText;
